import { useQuery } from '@tanstack/react-query'
import posthog from 'posthog-js'
import { getSession, type User } from '@/lib/api/client'
import { loadDataSources, resetDataSources, userScope } from '@/lib/data-source'
import { isPostHogConfigured } from '@/lib/posthog-logs'

let identifiedUserId: string | undefined

export function identifySessionUser(user: User) {
  if (identifiedUserId === userScope(user)) return

  if (identifiedUserId && isPostHogConfigured) posthog.reset()
  if (isPostHogConfigured)
    posthog.identify(user.id, {
      $name: user.displayName,
      username: user.username,
      store_id: user.storeId,
    })
  identifiedUserId = userScope(user)
  loadDataSources(user)
}

export function resetSessionUser() {
  if (isPostHogConfigured) posthog.reset()
  identifiedUserId = undefined
  resetDataSources()
}

export const sessionKey = ['auth', 'session'] as const
export function useSession() {
  return useQuery({
    queryKey: sessionKey,
    queryFn: getSession,
    staleTime: 0,
    gcTime: 0,
    refetchInterval: 60_000,
    refetchOnMount: false,
  })
}
